import React from 'react';
import { CheckMarkBgIcon } from '@assets/icons';
import { InformationBlue24Icon, SuccessGreen24Icon, WarningRed24Icon } from '@assets/icons/index';

export const getColor = ({ status }) => {
    const defaultColor = {
        borderColor: 'var(--color-danger60)',
        backgroundColor: 'var(--color-danger10)',
        icon: <WarningRed24Icon />,
    };

    const obj = {
        error: {
            borderColor: 'var(--color-danger60)',
            backgroundColor: 'var(--color-danger10)',
            icon: <WarningRed24Icon />,
        },
        failed: {
            borderColor: 'var(--color-danger60)',
            backgroundColor: 'var(--color-danger10)',
            icon: <WarningRed24Icon />,
        },
        success: {
            borderColor: 'var(--color-success60)',
            backgroundColor: 'var(--color-success10)',
            icon: <SuccessGreen24Icon />,
        },
        info: {
            borderColor: 'var(--color-info50)',
            backgroundColor: 'var(--color-info10)',
            icon: <InformationBlue24Icon />,
        },
        'warning-check': {
            borderColor: '#ffcd00',
            backgroundColor: 'warning.100',
            icon: <CheckMarkBgIcon />,
        },
    };

    return obj[status] || defaultColor;
};
